
import axios from "axios";


   import {apiUrl} from '../AxiosAPI' ;  

  // SignUp API post call with rest endpoint 
   export const AddToCartClientApp = (data) => axios.post(`${apiUrl}/AddToCartClientApp`,data);  
export const PlaceOrderClientApp = (data) => axios.post(`${apiUrl}/PlaceOrderClientApp`,data);  
export const razorpayPaymentAPIClient = (data) => axios.post(`${apiUrl}/razorpayPaymentAPIClient`,data);  
 